import { ChartSection, ChartHeader } from '@instamenu/ui-system-next';
import { ViewMoreTable } from '@/components/core/tables';
import { useSalesSummaryContext } from '../../SalesSummaryContext';
import { formatTimespan, formatTimeRange, formatCurrency } from '@instamenu/formatters';
import { useMediaQuery } from 'react-responsive';
import { useLocale } from '@instamenu/context-i18n';
import { createColumnHelper } from '@tanstack/react-table';
import { ItemStats } from '@instamenu/data-access-stats';
import { columnHelpers } from '@/components/core/tables/column-helpers';
import { sumBy } from 'lodash-es';

const columnHelper = createColumnHelper<Omit<ItemStats, 'discount'>>();

export default function TopAddons() {
  const { i18n } = useLocale();
  const isDesktop = useMediaQuery({ query: `(min-width: 768px)` });
  const { statsQuery, timespan, times } = useSalesSummaryContext();
  const [{ data, error, fetching }] = statsQuery;

  const columns = [
    columnHelper.accessor('quantity', {
      header: isDesktop
        ? i18n.t('salesSummary.topAddons.quantitySold')
        : i18n.t('salesSummary.topAddons.qty'),
      size: 200,
      footer: () => sumBy(data?.stats.topAddons, (x) => x.quantity),
    }),

    columnHelper.accessor('name', {
      header: i18n.t('salesSummary.topAddons.itemName'),
      size: 1000,
    }),
    columnHelper.accessor('amount', {
      ...columnHelpers.currency,
      header: i18n.t('salesSummary.topAddons.sales'),
      size: 100,
      footer: () => formatCurrency(sumBy(data?.stats.topAddons, (x) => x.amount)),
    }),
  ];

  return (
    <ChartSection
      empty={!(data?.stats.topAddons.length ?? 0 > 0)}
      loading={fetching}
      error={error}
      divide
      Header={
        <ChartHeader
          title={i18n.t('salesSummary.topAddons.topAddons')}
          subtitle={[formatTimespan(timespan, i18n), formatTimeRange(times)]
            .filter((x) => x)
            .join('; ')}
          csvOptions={{ data: data?.stats.topAddons, columns, filename: 'top-addons.csv' }}
        />
      }
    >
      <ViewMoreTable
        data={data?.stats.topAddons}
        columns={columns}
        initialState={{ sorting: [{ id: 'quantity', desc: true }] }}
      />
    </ChartSection>
  );
}
